import { crawlerCategoryLabel, type CrawlerFilter } from '~features/crawler-filter';
import {
  type EmptyScope,
  dateRangeContains,
  offeredScopeWindow,
  resolveEmptyScope,
  scopeCoversDefault,
  scopeNeedsCount,
} from './EmptyScope';
import { useCrawlerRequestsTotal } from './useCrawlerRequestsTotal';

type CrawlerList = { isSuccess: boolean; data?: string[] };

export type CrawlerTrafficEmptyScopeInput = {
  emptyInRange: boolean;
  crawlerList: CrawlerList;
  allDomains: boolean;
  crawlerFilter: CrawlerFilter;
  selectedCrawlerCategories: string[];
  dateFrom: Date;
  dateTo: Date;
  isPrinting: boolean;
};

export function useCrawlerTrafficEmptyScope({
  emptyInRange,
  crawlerList,
  allDomains,
  crawlerFilter,
  selectedCrawlerCategories,
  dateFrom,
  dateTo,
  isPrinting,
}: CrawlerTrafficEmptyScopeInput): EmptyScope {
  const coversDefault = scopeCoversDefault({ allDomains, crawlerFilter, dateFrom, dateTo });
  const scopeWindow = offeredScopeWindow(coversDefault);
  const facts = {
    emptyInRange,
    accountEverCrawled: crawlerList.isSuccess && Boolean(crawlerList.data?.length),
    coversDefault,
    rangeContainsOfferedWindow: dateRangeContains({ dateFrom, dateTo }, scopeWindow),
  };
  const count = useCrawlerRequestsTotal(scopeWindow, { skip: !scopeNeedsCount(facts) || isPrinting });

  return resolveEmptyScope({
    ...facts,
    scopeWindow,
    count,
    selectedCrawlerLabels: selectedCrawlerCategories.map(crawlerCategoryLabel),
  });
}
